<!--
* 组件名 : 章节首屏阶段卡片
* 开发者 : JY
*
* 参数:
*  images     { String }   required - 阶段缩略图
*  title      { String }   required - 阶段标题
*  slug       { String }   required - 对应阶段的路由
*  count      { Number }      [4]   - 卡片总数量
*
* 事件:  null
* 
-->

<template>
  <div
    :class="['v-stage-cards', label]"
    ref="stageCards"
    @click="go_children_nav"
  >
    <div class="cards-cover">
      <div class="cover-image"><v-img :path="images" /></div>
      <h4 class="page-stage-title" v-html="title" />
    </div>
  </div>
</template>

<script>
export default {
  name: "v-stage-cards",
  props: {
    images: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      label: "label-4",
    };
  },
  mounted() {
    this.label = this.count > 4 ? "label-3" : "label-4";
  },
  methods: {
    go_children_nav() {
      this.$router.push(this.slug);
    },
  },
};
</script>

<style lang="scss">
.v-stage-cards {
  margin-bottom: 40px;
  max-width: 33.333%;
  padding: 0 24px;
  cursor: pointer;

  &.label-4 {
    width: 25%;
  }

  &.label-3 {
    width: 33.333%;
  }

  .cards-cover {
    width: 100%;

    &:hover {
      img {
        transform: scale(1.02);
      }

      h4 {
        color: $color-chapter-title;
      }
    }
  }

  .cover-image {
    width: 100%;
    padding-top: 62.8%;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background-color: $color-placeholder;
    box-shadow: 2px 8px 20px 0 rgb(0 0 0 / 25%);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      transition: transform 0.5s ease;
      transform: scale(1);
      will-change: transform;
    }
  }

  .page-stage-title {
    margin-top: 16px;
  }

  @media (max-width: $lx-min) {
    padding: 0 16px;
  }
}
</style>
